import { ASSET_DECIMALS } from "./api";

/** "$67,421.55" — locale-aware, tabular-safe. */
export function formatPrice(asset: string, value: number): string {
  const dp = ASSET_DECIMALS[asset] ?? 2;
  return (
    "$" +
    value.toLocaleString("en-US", {
      minimumFractionDigits: dp,
      maximumFractionDigits: dp,
    })
  );
}

/** "0.3s" / "12.4s" / "1.2m" — staleness-friendly. */
export function formatAge(seconds: number): string {
  if (seconds < 60) return seconds.toFixed(1) + "s";
  if (seconds < 3600) return (seconds / 60).toFixed(1) + "m";
  return (seconds / 3600).toFixed(1) + "h";
}

/** "14d 3h" — for /health uptime. */
export function formatUptime(s: number | null | undefined): string {
  if (s == null) return "—";
  if (s < 60) return s + "s";
  if (s < 3600) return Math.floor(s / 60) + "m " + (s % 60) + "s";
  if (s < 86400)
    return (
      Math.floor(s / 3600) + "h " + Math.floor((s % 3600) / 60) + "m"
    );
  return (
    Math.floor(s / 86400) + "d " + Math.floor((s % 86400) / 3600) + "h"
  );
}

/** Shorten a Stellar contract ID for display: head…tail. */
export function shortContract(id: string, head = 6, tail = 4): string {
  if (id.length <= head + tail + 1) return id;
  return id.slice(0, head) + "…" + id.slice(-tail);
}

/** 3-state freshness class given an age in seconds. */
export function freshnessClass(age: number): "fresh" | "warning" | "stale" {
  if (age <= 1) return "fresh";
  if (age <= 3) return "warning";
  return "stale";
}
